import React, {Component} from 'react';
import Login from './Login';
import Register from './Register';
import axios from 'axios';
import {browserHistory} from 'react-router'
import { BASE_URL } from './constants/api';

class StepOne extends Component {
    constructor(props) {
        super(props);
        this.onBtnClickHandler = this.onBtnClickHandler.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.state = {
            selectedOption: 'login',
            userData: {},
            validField: {}
        }
    }

    componentWillMount() {
        let user = localStorage.getItem('user');
        if (user) {
            browserHistory.push(`/ChooseServices`)
        }
    }

    handleOptionChange(changeEvent) {
        this.setState({selectedOption: changeEvent.target.value});
    }

    handleInputChange(propName, value) {
        let data = {};
        data[propName] = value;
        this.setState({userData: Object.assign({}, this.state.userData, data)});
    }

    onBtnClickHandler(e) {
        e.preventDefault();
        this.state.selectedOption === 'login' ? this.sendLogin() : this.sendRegister()
    }

    firstNameIsValid(firstName) {
        this.setState({validField: {'firstName': ''}});
        if (!firstName) {
            return 'empty'
        } else if (firstName.trim().length > 20) {
            return 'many'
        } else {
            return ''
        }
    }

    lastNameIsValid(lastName) {
        this.setState({validField: {'lastName': ''}});
        if (!lastName) {
            return 'empty'
        } else if (lastName.trim().length > 20) {
            return 'many'
        } else {
            return ''
        }
    }

    checkConfirmPassword(password, confirmPassword) {
        this.setState({validField: {'passwordConfirmation': ''}});
        if (!confirmPassword) {
            return 'empty'
        } else if (password != confirmPassword) {
            return 'not_match'
        } else {
            return ''
        }
    }

    validationRegister(userData) {
        let valid = true
        let data = {};
        data['email'] = this.validationEmail(userData.email);
        data['password'] = this.passwordIsEmpty(userData.password);
        data['passwordConfirmation'] = this.checkConfirmPassword(userData.password, userData.confirmPassword);
        data['firstName'] = this.firstNameIsValid(userData.firstName);
        data['lastName'] = this.lastNameIsValid(userData.lastName);
        this.setState({validField: data});

        for (let k in data) {
            if (data[k] != "") {
                this.setState({validField: Object.assign({}, this.state.validField, data)});
                valid = false;
            }
        }
        return valid
    }

    sendRegister() {
        let email = this.state.userData.email;
        let password = this.state.userData.password;
        let password_confirmation = this.state.userData.confirmPassword;
        let first_name = this.state.userData.firstName;
        let last_name = this.state.userData.lastName;

        if (this.validationRegister(this.state.userData)) {
            axios.post(`${BASE_URL}/api/v1/sign_up`, {
                    user: {
                        email: email,
                        password: password,
                        password_confirmation: password_confirmation,
                        first_name: first_name,
                        last_name: last_name,
                    },
                    device_platform: 'web',
                    device_token: '',
                },
            ).then(function (response) {
                let data = {
                    token: response.headers['access-token'],
                    user_data: response.data
                };
                localStorage.setItem('user', JSON.stringify(data));
                browserHistory.push(`/ChooseServices`)
            }).catch(function (error) {
                if (error.response.data.type == "Unauthorized") {
                    localStorage.removeItem("servicesData");
                    localStorage.removeItem("appointment_details");
                    localStorage.removeItem("appointment");
                    localStorage.removeItem("services");
                    localStorage.removeItem("user");
                    alert(error.response.data.type);
                    browserHistory.push(`/StepOne`)
                } else {
                    alert(error.response.data.message);
                }
            });
        }
    }

    validationEmail(email) {
        let validator = require("email-validator");
        this.setState({validField: {'email': ''}});
        if (!email) {
            return 'empty';
        } else if (!validator.validate(email)) {
            return 'invalid';
        } else {
            return ''
        }
    }

    passwordIsEmpty(password) {
        this.setState({validField: {'password': ''}});
        if (!password) {
            return 'empty';
        } else if (password.length < 6) {
            return 'less'
        } else {
            return ''
        }
    }

    validationLogin(email, password) {
        let valid = true;
        let data = {};
        data['email'] = this.validationEmail(email);
        data['password'] = this.passwordIsEmpty(password);
        this.setState({validField: data});

        for (let k in data) {
            if (data[k] != "") {
                this.setState({validField: Object.assign({}, this.state.validField, data)});
                valid = false;
            }
        }
        return valid
    }

    sendLogin() {
        let email = this.state.userData.email;
        let password = this.state.userData.password;

        if (this.validationLogin(email, password)) {
            axios.post(`${BASE_URL}/api/v1/log_in`, {
                    user: {
                        email: email,
                        password: password
                    },
                    device_platform: 'web',
                    device_token: '',
                },
            ).then(function (response) {
                let data = {
                    token: response.headers['access-token'],
                    user_data: response.data
                };
                localStorage.setItem('user', JSON.stringify(data));
                browserHistory.push(`/ChooseServices`)

            }).catch(function (error) {
                if (error.response.data.type == "Unauthorized"){
                    alert(error.response.data.type);
                    localStorage.removeItem("servicesData");
                    localStorage.removeItem("appointment_details");
                    localStorage.removeItem("appointment");
                    localStorage.removeItem("services");
                    browserHistory.push(`/StepOne`)
                } else {
                    alert(error.response.data.message);
                }
            });
        }
    }

    render() {
        let selectedOption = this.state.selectedOption;
        return (
            <div className="smart-wrap">
                <div className="smart-forms smart-container wrap-2">
                    <div className="form-header header-lite">
                        <h4>Login/Register</h4>
                    </div>
                    <div className="form-body smart-steps steps-theme-primary">
                        <form method="post" action="#" id="smart-form">
                            <fieldset>
                                <h3 className="subtitle">Create your account or sign in to your existing account to
                                    continue. </h3>
                                <div className="section">
                                    <div className="option-group field loginpage">
                                        <label className="option">
                                            <input type="radio"
                                                   name="package"
                                                   className="smartfm-ctrl"
                                                   value="register"
                                                   data-show-id="ctr_personal"
                                                   checked={this.state.selectedOption === 'register'}
                                                   onChange={this.handleOptionChange}
                                            />
                                            <span className="radio"></span> Register
                                        </label>
                                        <label className="option">
                                            <input type="radio"
                                                   name="package"
                                                   className="smartfm-ctrl"
                                                   value="login"
                                                   data-show-id="ctr_business"
                                                   checked={this.state.selectedOption === 'login'}
                                                   onChange={this.handleOptionChange}
                                            />
                                            <span className="radio"></span> Login
                                        </label>
                                    </div>
                                </div>
                                {
                                    selectedOption === 'login' ?
                                        (
                                            <Login
                                                validField={this.state.validField}
                                                handleInputChange={this.handleInputChange}
                                            />
                                        ) :
                                        (
                                            <Register
                                                validField={this.state.validField}
                                                handleInputChange={this.handleInputChange}
                                            />
                                        )
                                }
                                <div className="controls">
                                    <div className="sendit">
                                        <button
                                            type="submit"
                                            className="button btn-primary"
                                            onClick={this.onBtnClickHandler}
                                        >
                                            CONTINUE
                                        </button>
                                    </div>
                                </div>
                                <div className="text-center backer"><a href="http://gostylu.com/book-now/"
                                                                       className="back">&larr;  Back</a></div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

export default StepOne;



/** WEBPACK FOOTER **
 ** ./src/StepOne.js
 **/